'use client';

import { ReactNode } from 'react';

import { useConsents } from '@/providers/consents';

interface Props {
  children: ReactNode;
}

const ConsentSettingsView = ({ children }: Props) => {
  const { consentSettingsOpen } = useConsents();

  if (!consentSettingsOpen) return null;

  return children;
};

export default ConsentSettingsView;
